import React, { useEffect, useState } from "react";
import { CategoryType } from "./components/CategorySelect";
import useLocalStorage from "./hooks/useLocalStorage";

import Search from "./routes/search";
import Channel, { loader as channelLoader } from "./routes/channel";
import Login, { action as loginAction } from "./routes/login";
import Recommended from "./routes/recommended";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ErrorPage from "./components/ErrorPage";
import Blog, { loader as blogLoader } from "./routes/blog";
import DashboardRoot from "./routes/dashboard/root";
import Dashboard from "./routes/dashboard";
import Posts, { loader as postsLoader } from "./routes/dashboard/posts";
import EditPost, {
    loader as editPostLoader,
} from "./routes/dashboard/posts/edit";
import Post, { loader as postLoader } from "./routes/dashboard/posts/view";
import Root from "./routes/root";
import Tutorial from "./routes/tutorial";

const router = createBrowserRouter([
    {
        path: "/",
        element: <Root />,
        errorElement: <ErrorPage />,
        children: [
            {
                index: true,
                element: <Tutorial />,
            },
            {
                path: "recommended",
                element: <Recommended />,
            },
            {
                path: "search",
                element: <Search />,
            },
            {
                path: "channel/:sub/:channel",
                element: <Channel />,
                loader: channelLoader,
            },
            {
                path: "login",
                action: loginAction,
                element: <Login />,
            },
            {
                path: "blog",
                loader: blogLoader,
                element: <Blog />,
            },
            {
                path: "blog/:id",
                element: <Post />,
                loader: postLoader,
            },
        ],
    },
    {
        path: "/dashboard",
        element: <DashboardRoot />,
        errorElement: <ErrorPage />,
        children: [
            {
                index: true,
                element: <Dashboard />,
            },
            {
                path: "posts",
                children: [
                    {
                        index: true,
                        element: <Posts />,
                        loader: postsLoader,
                    },
                    {
                        path: ":id",
                        element: <Post />,
                    },
                    {
                        path: "edit/:id",
                        element: <EditPost />,
                        loader: editPostLoader,
                    },
                ],
            },
        ],
    },
]);

export interface AppContextType {
    category: CategoryType;
    setCategory: (category: CategoryType) => void;
    auth: string | null;
    setAuth: (auth: string) => void;
}

export const AppContext = React.createContext<AppContextType | null>(null);

export default function App() {
    useEffect(() => {
        console.log(window.location.href);
    }, []);

    const [categoryType, setCategoryType] = useLocalStorage(
        "category",
        "hetero"
    ) as [CategoryType, () => void];

    const [auth, setAuth] = useState<string | null>(null);

    return (
        <AppContext.Provider
            value={{
                category: categoryType,
                setCategory: setCategoryType,
                auth,
                setAuth,
            }}
        >
            <RouterProvider router={router} />
        </AppContext.Provider>
    );
}
